import React, { ReactElement, ReactNode } from 'react';
import { Box } from '@mui/material';

import Header from '../Header/Header';
import Footer from '../Footer/Footer';

interface IUnsubscribeLayoutProps {
  children: ReactNode;
}

const UnsubscribeLayout = ({ children }: IUnsubscribeLayoutProps): ReactElement => (
  <Box
    data-testid="rootUnsubscribeLayoutBox"
    width="100%"
    minHeight="100vh"
    height="auto"
    bgcolor="background.grey"
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    p={{ xs: 1, sm: 2, lg: 4 }}
  >
    <Box display="flex" flexDirection="column" justifyContent="flex-start">
      <Header />
      {children}
    </Box>
    <Footer />
  </Box>
);

export default UnsubscribeLayout;
